<template>
  <div>
    <check-authorization
      :requiresAuthorizations="requiresAuthorizations"
      no-slots
      :show-alert="false"
      #default="{ authorized }"
    >
      <router-link v-if="authorized" :to="to" class="nav-link">
        <slot></slot>
      </router-link>

      <!--
        Opción sin permiso: se muestra deshabilitada con un candado.
        Al pasar el mouse o hacer clic sobre el candado se indica el permiso que falta.
      -->
      <div v-else class="nav-link disabled text-muted sidebar-link--locked">
        <slot></slot>
        <span
          v-if="showPermissionHelp"
          :id="lockId"
          class="sidebar-link__lock"
          tabindex="0"
          role="button"
          aria-label="Permiso requerido"
        >
          <b-icon-lock-fill></b-icon-lock-fill>
        </span>
        <b-popover
          v-if="showPermissionHelp"
          :target="lockId"
          triggers="hover focus click"
          placement="right"
          boundary="window"
          container="body"
        >
          <div class="small">
            Necesitas el permiso
            <b v-for="p in requiresAuthorizations" :key="p" class="d-block">{{ p }}</b>
            <span class="text-muted">Pídelo al administrador del sistema.</span>
          </div>
        </b-popover>
      </div>
    </check-authorization>
  </div>
</template>

<script>
let uid = 0

export default {
  name: 'SidebarLink',

  props: {
    requiresAuthorizations: {
      type: Array,
      required: true
    },

    to: {
      type: Object,
      required: true
    },

    showPermissionHelp: {
      type: Boolean,
      required: false,
      default: true
    }
  },

  data () {
    uid += 1
    return {
      lockId: `sidebar-lock-${uid}`
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar-link--locked {
  display: flex;
  align-items: center;
  cursor: default;
}

.sidebar-link__lock {
  // .nav-link.disabled desactiva el puntero; el candado sí debe responder.
  pointer-events: auto !important;
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.4rem;
  height: 1.4rem;
  border-radius: 50%;
  background: #f2f4f8;
  color: #a7aeb8;
  font-size: 0.65rem;
  cursor: pointer;

  &:hover,
  &:focus {
    background: #fde8e8;
    color: #e81500;
    outline: none;
  }
}
</style>
